// extracted by mini-css-extract-plugin
module.exports = {"flash":"LogoutOnInactivity_flash__qn560"};